"use client";

import { alpha } from "@mui/material/styles";
import { blue, gray, green, orange, red } from "../theme-primitives";

export const feedbackCustomizations = {
  MuiAlert: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 10,
        backgroundColor: blue[100],
        color: blue.text,
        border: `1px solid ${alpha(blue[300], 0.5)}`,
        "& .MuiAlert-icon": {
          color: blue[500],
        },
        ...theme.applyStyles("dark", {
          backgroundColor: `${alpha(blue[900], 0.5)}`,
          border: `1px solid ${alpha(blue[800], 0.5)}`,
        }),
        variants: [
          {
            props: {
              severity: "error",
            },
            style: {
              backgroundColor: red[100],
              color: red.text,
              border: `1px solid ${alpha(red[300], 0.5)}`,
              "& .MuiAlert-icon": {
                color: red[500],
              },
              ...theme.applyStyles("dark", {
                backgroundColor: `${alpha(red[900], 0.5)}`,
                border: `1px solid ${alpha(red[800], 0.5)}`,
              }),
            },
          },
          {
            props: {
              severity: "warning",
            },
            style: {
              backgroundColor: orange[100],
              color: orange.text,
              border: `1px solid ${alpha(orange[300], 0.5)}`,
              "& .MuiAlert-icon": {
                color: orange[500],
              },
              ...theme.applyStyles("dark", {
                backgroundColor: `${alpha(orange[900], 0.5)}`,
                border: `1px solid ${alpha(orange[800], 0.5)}`,
              }),
            },
          },
          {
            props: {
              severity: "info",
            },
            style: {
              backgroundColor: blue[100],
              color: blue.text,
              border: `1px solid ${alpha(blue[300], 0.5)}`,
              "& .MuiAlert-icon": {
                color: blue[500],
              },
              ...theme.applyStyles("dark", {
                backgroundColor: `${alpha(blue[900], 0.5)}`,
                border: `1px solid ${alpha(blue[800], 0.5)}`,
              }),
            },
          },
          {
            props: {
              severity: "success",
            },
            style: {
              backgroundColor: green[100],
              color: green.text,
              border: `1px solid ${alpha(green[300], 0.5)}`,
              "& .MuiAlert-icon": {
                color: green[500],
              },
              ...theme.applyStyles("dark", {
                backgroundColor: `${alpha(green[900], 0.5)}`,
                border: `1px solid ${alpha(green[800], 0.5)}`,
              }),
            },
          },
        ],
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        "& .MuiDialog-paper": {
          borderRadius: "10px",
          border: "1px solid",
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles("dark", {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
};
